'use strict';

const aircraftmapUtils = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.utils');
const AircraftMapTemplate = function(options) {
    aircraftmapUtils.options = aircraftmapUtils.parseOptions(options);
};

AircraftMapTemplate.prototype = {
    buildTemplate: function() {
        aircraftmapUtils.setSeatPriceData(aircraftmapUtils.options.seatMap.cabin);
        return $('<div>', {class: aircraftmapUtils.constants.AIRCRAFT_WRAPPER_CLASS})
            .append(this.buildBody());
    },
    buildBody: function() {
        const $cabins = $('<div>');
        Odigeo._.each(aircraftmapUtils.options.seatMap.cabin, Odigeo._.bind(function(cabin) {
            const $darkZone = aircraftmapUtils.hasToShowDarkZone(cabin) ? aircraftmapUtils.addDarkZone(cabin) : '';
            $cabins.append(this.buildCabin(cabin))
                .append($darkZone);
        }, this));
        return $cabins;
    },
    buildNoSeatsRow: function(cabin, seatRow, seatMapRow) {
        let $elements = [];
        const $noSeatsRow = $('<div>', {class: `odf-row
            ${aircraftmapUtils.constants.ROW_CLASS}`});

        $noSeatsRow.append($('<div>', {
            class: `odf-text-sm odf-text-center
                ${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}
                ${aircraftmapUtils.constants.ROW_REFERENCE_CLASS}`,
        }));

        Odigeo._.each(cabin.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(columnCount) {
            if (columnCount === 'AISLE') {
                $noSeatsRow.append(
                    $('<div>', {
                        class: `
                        ${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                        ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}`,
                    }));
            } else {
                let $noSeat = this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount));
                const $noSeatWrapper = $('<div>', {class: 'odf-col odf-col-nogutter odf-col-bottom'}).append($noSeat);
                $noSeatsRow.append($noSeatWrapper);
            }
        }, this));
        $elements.push($noSeatsRow);
        return $elements;
    },
    buildRow: function(cabin, seatRow, seatMapRow) {
        let $elements = [];
        let $row = $('<div>', {class: `odf-row ${aircraftmapUtils.constants.ROW_CLASS}`});
        const extraLegSeats = aircraftmapUtils.getCustomRowElement(cabin.cabinCharacteristics.extraLegSeats, aircraftmapUtils.constants.BLANK_SPACE);

        $row.append($('<div>', {
            class: `odf-text-sm odf-text-center
                ${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}
                ${aircraftmapUtils.constants.ROW_REFERENCE_CLASS}`,
        }).append(seatRow));

        let $rowSeat = $('<div>', {class: `odf-row od-keep-ltr`});
        Odigeo._.each(cabin.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(columnCount) {
            if (columnCount === 'AISLE') {
                $rowSeat.append($('<div>', {class: `odf-text-sm odf-text-center
                    ${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                    ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}`}));
            } else {
                const $seat = aircraftmapUtils.isSeatExtraLeg(extraLegSeats, seatRow, columnCount)
                    ? this.buildExtraLegSeat(cabin, seatRow, seatMapRow, columnCount)
                    : this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount));
                const $seatWrapper = $('<div>', {class: 'odf-col odf-col-nogutter odf-col-bottom'}).append($seat);
                $rowSeat.append($seatWrapper);
            }
        }, this));
        $row.append($rowSeat);
        $elements.push($row);
        return $elements;
    },
    buildCabin: function(cabin) {
        let $cabin = $('<div>', {class: `${aircraftmapUtils.constants.COLOR_SEAT_CABIN_CLASS} ${aircraftmapUtils.constants.CABINS_CLASS}`});
        const $columnReference = $('<div>', {class: aircraftmapUtils.constants.ROW_CLASS})
            .append(this.buildColumnReferenceRow(cabin));
        $cabin.append($columnReference);

        let seatRow = cabin.firstSeatsRow;
        Odigeo._.each(Odigeo._.range(cabin.seatMapRowFrom, cabin.seatMapRowTo + 1), Odigeo._.bind(function(seatMapRow) {
            const row = aircraftmapUtils.getSeatRowFromSeatMapRow(cabin, seatMapRow);
            const exitRows = aircraftmapUtils.getCustomRowElement(cabin.cabinCharacteristics.exitRows, aircraftmapUtils.constants.BLANK_SPACE);
            seatRow = row > aircraftmapUtils.constants.NO_SEATS ? row : seatRow;

            if (row === aircraftmapUtils.constants.BLANK_SEATS) {
                $cabin.append($('<div>', {class: aircraftmapUtils.constants.ROW_CLASS})
                    .append(this.buildNoSeatsRow(cabin, aircraftmapUtils.constants.BLANK_SEATS, seatMapRow)));
                seatRow++;
            } else if (row > aircraftmapUtils.constants.BLANK_SEATS) {
                if (aircraftmapUtils.isExitRow(exitRows, seatRow.toString())) {
                    $cabin.append(aircraftmapUtils.addExitRow(seatRow));
                }
                $cabin.append($('<div>', {class: aircraftmapUtils.constants.ROW_CLASS})
                    .append(this.buildRow(cabin, seatRow, seatMapRow)));
                seatRow++;
            }
        }, this));
        return $cabin;
    },
    buildColumnReferenceRow: function(cabinInfo) {
        let $elements = [];
        const $noSeatsRow = $('<div>', {class: `odf-row od-keep-ltr od-aircraftmap-numbers-row ${aircraftmapUtils.constants.ROW_CLASS}`});

        $elements.push(
            $('<div>', {
                class: `${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                    ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}
                    ${aircraftmapUtils.constants.ROW_REFERENCE_CLASS}`,
            }));

        Odigeo._.each(cabinInfo.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(columnCount) {
            if (columnCount === 'AISLE') {
                $elements.push(
                    $('<div>', {
                        class: `${aircraftmapUtils.constants.COLOR_SEAT_ROW_CLASS}
                            ${aircraftmapUtils.constants.SEAT_AISLE_CLASS}`,
                    }));
            } else {
                $elements.push($('<div>', {class: 'odf-col odf-col-nogutter odf-col-bottom'}).append(this.buildColumnReference(columnCount)));
            }
        }, this));
        return $noSeatsRow.append($elements);
    },
    buildColumnReference: function(columnId) {
        const columnReferenceClasses = `odf-text-center odf-text-lg odf-col odf-col-nogutter odf-strong
            ${aircraftmapUtils.constants.COLUMN_REFERENCE_CLASS}
            ${aircraftmapUtils.constants.AIRCRAFT_SEAT_CLASS}`;
        return $('<div>', {
            class: columnReferenceClasses,
        }).html(columnId);
    },
    buildExtraLegSeat: function(cabin, seatRow, seatMapRow, columnCount) {
        const $extraLegSeat = $('<div>', {class: `odf-col odf-col-nogutter ${aircraftmapUtils.constants.ROW_EXTRA_LEG_CLASS}`});
        const $seat = this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount));
        return $extraLegSeat.append($seat);
    },
    buildSeat: function(seat) {
        const isExtraLeg = aircraftmapUtils.hasExtraLegCharacteristic(seat);
        const section = Odigeo._.get(aircraftmapUtils, 'options.section');
        const preferredSeatsThreshold = Odigeo._.get(aircraftmapUtils, 'options.preferredSeatsThreshold');
        const cheaperSeatPrice = Odigeo._.get(aircraftmapUtils, 'options.cheaperSeatPrice');
        const aircraftInfo = {
            cheaperSeatPrice,
            differentSeatPrices: Odigeo._.get(aircraftmapUtils, 'options.differentSeatPrices'),
            preferredSeatsThreshold: aircraftmapUtils.getSectionPreferredThreshold(section, preferredSeatsThreshold),
            section,
        };

        const mainCharacteristic = aircraftmapUtils.getSeatMainCharacteristic(seat, aircraftInfo);
        const characteristicClasses = aircraftmapUtils.getSeatCharacteristicClasses(seat, aircraftInfo);


        return $('<div>', {class: `odf-col odf-col-nogutter ${this.buildSeatContent(seat)} ${characteristicClasses}`})
            .attr('id', 'aircraft_map_' + seat.row + seat.column)
            .attr('data-status', seat.status)
            .attr('data-row', seat.row)
            .attr('data-extra-leg', isExtraLeg)
            .attr('data-column', seat.column)
            .attr('data-characteristic', mainCharacteristic)
            .attr('data-rawprice', seat.rawPrice);
    },
    buildSeatContent: function(seat) {
        const seatDisponibilityClasses = aircraftmapUtils.isUnavailableOrNoSeat(seat) ?
            this.getNoSelectableOrNoSeatClasses(seat) : aircraftmapUtils.constants.AIRCRAFT_SEAT_CLASS;
        return `${aircraftmapUtils.constants.COLOR_SEAT_GENERIC_CLASS} ${seatDisponibilityClasses}`;
    },
    getNoSelectableOrNoSeatClasses: function(seat) {
        return seat.type === aircraftmapUtils.options.seatStatus.unavailable ? this.getNoSelectableSeatClasses() : this.getNoSeatBlockClasses(seat);
    },
    getNoSelectableSeatClasses: function() {
        return `odf-text-lg odf-icon-cross-light ${aircraftmapUtils.constants.AIRCRAFT_SEAT_CLASS}`;
    },
    getNoSeatBlockClasses: function(seat) {
        return this.isSpecialAircraftBlock(seat) ?
            this.getSpecialAircraftBlockClasses(seat.characteristics.characteristic) : aircraftmapUtils.constants.AIRCRAFT_NO_SEAT_CLASS;
    },
    isSpecialAircraftBlock: function(seat) {
        return aircraftmapUtils.isNoSeat(seat)
            && !Odigeo._.isEmpty(seat.characteristics.characteristic)
            && aircraftmapUtils.isSeatLavatory(seat.characteristics.characteristic);
    },
    getSpecialAircraftBlockClasses: function(characteristics) {
        return `odf-text-xl odf-icon ${aircraftmapUtils.constants.AIRCRAFT_NO_SEAT_CLASS} ${aircraftmapUtils.getNoSeatType(characteristics)}`;
    },
};

module.exports = AircraftMapTemplate.prototype.constructor = AircraftMapTemplate;
